import { constants } from "@thecb/components";
import styled, { css } from "styled-components";

const { PILL_COLORS } = constants.colors;

const StyledPill = styled.span`
  background-color: ${PILL_COLORS.neutral.background};
  color: ${PILL_COLORS.neutral.text};
  padding: 2px 8px;
  border-radius: 2px;
  font-size: 0.875rem;
  text-overflow: ellipsis;
  max-width: inherit;
  overflow: hidden;

  ${(props) =>
    props.success &&
    css`
      background-color: ${PILL_COLORS.success.background};
      color: ${PILL_COLORS.success.text};
    `}

  ${(props) =>
    props.warning &&
    css`
      background-color: ${PILL_COLORS.warning.background};
      color: ${PILL_COLORS.warning.text};
    `}

  ${(props) =>
    props.danger &&
    css`
      background-color: ${PILL_COLORS.danger.background};
      color: ${PILL_COLORS.danger.text};
    `}
`;

export default StyledPill;
